import { render, staticRenderFns } from "./Tab-Invoice-Franchise.vue?vue&type=template&id=0259d043"
import script from "./Tab-Invoice-Franchise.vue?vue&type=script&lang=js"
export * from "./Tab-Invoice-Franchise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports